import { ModelRepository } from 'b302-frontend-library';
import Continent from '../models/Continent';

class ContinentRepository extends ModelRepository<Continent> {

    public constructor() {
        super('/continents');
    }

}

export default ContinentRepository;
